import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const BusinessTaskStore = {
  namespaced: true,
  state: {
    businessesMonthlyStatesTask: []
  },
  getters,
  mutations,
  actions
}

export default BusinessTaskStore